export { SizeFitLabelBanner } from "./SizeFitLabelBanner";
